var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-danger",on:{"click":function($event){$event.preventDefault();return _vm.deleteFile.apply(null, arguments)}}},[_c('i',{staticClass:"fa fa-lg fa-trash"})])
}
var staticRenderFns = []

export { render, staticRenderFns }